const getCurrentAppDocuments = (documents, appInfo) => appInfo.AppID
  ? documents.filter(item => !item.AppID || item.AppID.indexOf(appInfo.AppID) !== -1)
  : documents.filter(item => !item.AppID);

export default getCurrentAppDocuments;



// WEBPACK FOOTER //
// ./src/utils/getCurrentAppDocuments.js